import { useEffect, useContext } from 'react';
import CompanyReport from 'kosmos/components/companyReport';
import { tfpDefaultMenuList, reportSectionMenus } from 'kosmos/TfpApp';
import MenuConfigContext from 'data/MenuConfigContext';
import { useTranslation } from 'react-i18next';

interface IProps {
  id: string;
  organisationId?: string;
  reportSnapshotId?: string;
  onBack?: () => void;
}

export default function CompanyReportWithMenus(props: IProps): JSX.Element {
  const { id, organisationId, reportSnapshotId, onBack } = props;
  const context = useContext(MenuConfigContext);
  const { t } = useTranslation('default');

  useEffect(() => {
    const { setMenuItems } = context;
    setMenuItems && setMenuItems(reportSectionMenus(t));
    return () => {
      // unmount, clear menu
      setMenuItems && setMenuItems(tfpDefaultMenuList(t));
    };
  }, []);

  return <CompanyReport id={id} organisationId={organisationId} reportSnapshotId={reportSnapshotId} onBack={onBack} />;
}
